import { createContext } from "react";

interface ContextType {
  queuedCount: number | null;
}

export const SiteCableContext = createContext<ContextType>({
  queuedCount: null,
});
